import { ChakraProvider } from "@chakra-ui/react";
import store from "app/store";
import Router from "components/Router";
import { ConnectedRouter } from "connected-react-router";
import { ROOT_DOMAINS } from "constants/auth";
import { HOMEPAGE_ROUTE, SSO_VIEWER } from "constants/router";
import { useEffect, useLayoutEffect } from "react";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import routes from "routes";
import { history, theme } from "utils";

const persistor = persistStore(store);

function App() {
  useLayoutEffect(() => {
    if (history.location.pathname === HOMEPAGE_ROUTE) history.push(SSO_VIEWER);
  }, []);

  useEffect(() => {
    if (!window.hasOwnProperty("addEventListener")) {
      console.log("window", window);
      localStorage.setItem("rootDomain", window.name);
    } else {
      window.addEventListener("message", (event: any) => {
        if (ROOT_DOMAINS.includes(event.target.name)) {
          localStorage.setItem("rootDomain", event.target.name);
        }
      });
    }
  }, []);

  useEffect(() => {
    console.log(`version: 1.0.1`);
  }, []);

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ChakraProvider theme={theme}>
          <PersistGate loading={null} persistor={persistor}>
            <Router routes={routes} />
          </PersistGate>
        </ChakraProvider>
      </ConnectedRouter>
    </Provider>
  );
}

export default App;
